var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.777,28.782 L28.69,28.782 L28.69,6 L26.777,6 L26.777,28.782 Z M18.952,28.782 L20.865,28.782 L20.865,16.765 L18.952,16.765 L18.952,28.782 Z M11.125,28.782 L13.038,28.782 L13.038,14.261 L11.125,14.261 L11.125,28.782 Z M3.299,28.782 L5.212,28.782 L5.212,24.521 L3.299,24.521 L3.299,28.782 Z M31,28.782 L30.69,28.782 L30.69,5.626 C30.69,4.729 29.949,4 29.039,4 L26.43,4 C25.519,4 24.777,4.729 24.777,5.626 L24.777,28.782 L22.865,28.782 L22.865,16.391 C22.865,15.494 22.124,14.765 21.212,14.765 L18.604,14.765 C17.693,14.765 16.952,15.494 16.952,16.391 L16.952,28.782 L15.039,28.782 L15.039,13.886 C15.039,12.99 14.297,12.261 13.386,12.261 L10.777,12.261 C9.867,12.261 9.125,12.99 9.125,13.886 L9.125,28.782 L7.212,28.782 L7.212,24.147 C7.212,23.251 6.471,22.521 5.56,22.521 L2.952,22.521 C2.041,22.521 1.299,23.251 1.299,24.147 L1.299,28.782 L1,28.782 C0.448,28.782 0,29.23 0,29.782 C0,30.334 0.448,30.782 1,30.782 L31,30.782 C31.552,30.782 32,30.334 32,29.782 C32,29.23 31.552,28.782 31,28.782 L31,28.782 Z",
    id: "path-6229d2ef-420b-4e0b-91dd-144c10a482cc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-analyticsLarge"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6229d2ef-420b-4e0b-91dd-144c10a482cc",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6229d2ef-420b-4e0b-91dd-144c10a482cc"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "currentColor",
    xlinkHref: "#path-6229d2ef-420b-4e0b-91dd-144c10a482cc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "currentColor",
    mask: "url(#mask-6229d2ef-420b-4e0b-91dd-144c10a482cc)",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsLarge);
export default __webpack_public_path__ + "static/media/analyticsLarge.2426f46566eb11b4b1df1e90c56bbe73.svg";
export { ForwardRef as ReactComponent };